    document.addEventListener('DOMContentLoaded', function() {
      var links = document.links; // Get all <a> elements
      for (let i = 0, linksLength = links.length; i < linksLength; i++) {
        // Check if the link's hostname is different from the current site's hostname
        if (links[i].hostname !== window.location.hostname) {
          links[i].target = '_blank'; // Open in a new tab
          links[i].rel = 'noreferrer noopener'; // Recommended for security and SEO
        }
      }
    });